import React from 'react';
import PricingCards from '../components/payment/PricingCards';
import { useAuth } from '../context/AuthContext'; // 1. Import useAuth
import { useNavigate } from 'react-router-dom'; // 2. Import useNavigate
import { ROUTES } from '../lib/constants';

const Pricing = () => {
  const { refreshProfile } = useAuth(); // 3. Get refresh function
  const navigate = useNavigate();

  const handleSuccess = async () => {
    // 4. Force the app to check Supabase for the new 'premium' status
    await refreshProfile(); 
    // 5. Take them to the dashboard where the quiz is now unlocked
    navigate(ROUTES.DASHBOARD); 
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-cream-50 via-cream-100 to-brown-50">
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {/* Pass the new handler to your cards */}
        <PricingCards onSuccess={handleSuccess} />
      </main>
    </div>
  );
};

export default Pricing;